import {
  getAttorneyBulkInvoiceAmount,
  getAttorneyInvoiceAmount,
} from "../../utils/attorneyInvoicePricing";
import React, { useState, useEffect, useRef } from "react";
import DashBoardSidebar from "../../layouts/dashBoard-Sidebar";
import DashboardNavbar from "../../layouts/dashboardNavbar";
import { toast } from "react-toastify";
import moment from "moment";
import { ThreeDots } from "react-loader-spinner";
import { Link } from "react-router-dom";
import { useLocation, useNavigate } from "react-router-dom";
import {
  AttorneyPendingBillingUserByFilter,
  exportAtorneyInvoice,
} from "../../api/server";
import { FaArrowLeft } from "react-icons/fa";
import "./BillingWorkspace.css";
import BillingFilterDropdown from "./BillingFilterDropdown";

const InvoiceMOdalComponent = () => {
  const [response, setResponse] = useState({});
  const [loadingPdf, setLoadingPdf] = useState(false);
  const [loadingExcel, setLoadingExcel] = useState(false);

  const [serviceFee, setServiceFee] = useState(3);
  const [courseAmount, setCourseAmount] = useState("");
  const [totalCourses, setTotalCourses] = useState(0);
  const [grandTotal, setGrandTotal] = useState(0);
  const [credit, setCredit] = useState(0);
  const [monthFilter, setMonthFilter] = useState("all");
  const [loading, setLoading] = useState(false);
  const latestFetch = useRef(0);
  const navigate = useNavigate();
  // const [searchParams] = useSearchParams();
  const location = useLocation();
  // const course = searchParams.get("course");
  //  const { course } = useParams();
  //    const email = location.state?.email;
  const attorneyData = location.state?.attorneyData;
  const course = location.state?.courseParam;

//   console.log("course>>>>>", course, attorneyData);
  const fetchData = async (monthFilter = "all") => {
    const payload = {
      // course: course,
      // course: attorneyData?.course == "CC,DE" ?  "both" : attorneyData?.course == "CC" ? "first" : "second" ,
      course: course,
      email: attorneyData.email,
      code: attorneyData.attorneyCode,
    };
    const requestId = ++latestFetch.current;
    setLoading(true);
    try {
    const data = await AttorneyPendingBillingUserByFilter(payload,monthFilter);
    if (requestId !== latestFetch.current) return;
    if (data?.data?.message === "Success") {
      const modifiedData = {};
      Object.entries(data?.data?.pendingBillingUserList || {}).forEach(
        ([key, arr]) => {
          modifiedData[key] = arr.map((item) => ({
            ...item,
            amount: getAttorneyInvoiceAmount(item),
          }));
        }
      );
      const students = Object.values(modifiedData).flat();
      setCourseAmount(getAttorneyBulkInvoiceAmount(students, monthFilter))
      setServiceFee(3)
      setGrandTotal(0)
      setCredit(0)
      setResponse(modifiedData);
    } else {
      setResponse({});
      toast.error("Unable to load invoice students");
    }
    } catch (error) {
      if (requestId !== latestFetch.current) return;
      setResponse({});
      toast.error("Unable to load invoice students");
    } finally {
      if (requestId === latestFetch.current) setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (response) {
      let total = 0;
      Object.values(response).forEach((arr) => {
        arr.forEach((r) => {
          total += parseFloat(r.amount || 0);
        });
      });
      setTotalCourses(total.toFixed(2));
      const feeAmount = (parseFloat(serviceFee || 0) / 100) * total;
      //  setGrandTotal(total + feeAmount);
      setGrandTotal(total + feeAmount - credit);
    }
  }, [response, serviceFee, credit]);

const handleAmountChange = (courseKey, index, value) => {
  const updated = { ...response };

  // Allow decimals while typing
  updated[courseKey][index].amount = value;

  setResponse(updated);
};
  const handleRemoveStudent = (courseKey, index) => {
    const updated = { ...response };
    updated[courseKey].splice(index, 1); // remove

    // If course becomes empty → delete or keep empty (both ok)
    if (updated[courseKey].length === 0) {
      updated[courseKey] = [];
    }

    setResponse(updated);
  };

  const handleExport = async (type) => {
    const invoiceCourse =
      attorneyData?.course === "CC,DE"
        ? "both"
        : attorneyData?.course === "CC"
        ? "first"
        : "second";
    const courseKeys =
      invoiceCourse === "both"
        ? ["CC", "DE"]
        : [invoiceCourse === "first" ? "CC" : "DE"];
    const students = {};
    courseKeys.forEach((courseKey) => {
      students[courseKey] = {
        data: (response[courseKey] || []).map((student) => ({
          id: student.id,
          name: student.name,
          email: student.email,
          enrolDate: student.enrolDate,
          amount: `$${parseFloat(student.amount || 0).toFixed(2)}`,
        })),
      };
    });
    const payload = {
      type:type ,
      attorneyId: attorneyData?.id,
      course: invoiceCourse,
      attorneyName: attorneyData?.name,
      totalCourse: `$${Number(totalCourses)?.toFixed(2)}`,
      serviceAmount: `$${((totalCourses * (serviceFee || 0)) / 100).toFixed(
        2
      )}`,
      servicePercentage: `${serviceFee}`,
      total: `$${grandTotal.toFixed(2)}`,
      students,
      credit, // grouped by course
    };
    // console.log("Payload:", payload);
    if(type === "pdf"){
    setLoadingPdf(true);
    } else {
      setLoadingExcel(true);
    }
    try {
      const res = await exportAtorneyInvoice(payload);
      if (res?.data?.success) {
        if(type === "pdf"){
        setLoadingPdf(false);
        }else {
          setLoadingExcel(false);
        }
        toast.success("Invoice Generated Successfully!");
        const link = res?.data?.data;
        if (link) {
          const anchor = document.createElement("a");
          anchor.href = link;
          anchor.setAttribute("download", "invoice.pdf");
          anchor.setAttribute("target", "_blank");
          document.body.appendChild(anchor);
          anchor.click();
          document.body.removeChild(anchor);
        }
        // setShowModal(false);
        // fetchParentData(true);
        // navigate(`?show=false`)
        navigate(-1);
      } else {
        if(type === "pdf"){
        setLoadingPdf(false);
        } else {
          setLoadingExcel(false);
        }
        toast.error("There is some error");
      }
    } catch (error) {
      console.error("Export error:", error);
      if(type === "pdf"){
        setLoadingPdf(false);
      } else {
        setLoadingExcel(false);
      }
      toast.error("Something went wrong!");
    }
  };
const applyAmountToAll = (value) => {
  const updated = {};
  Object.entries(response).forEach(([courseKey, arr]) => {
    updated[courseKey] = arr.map((student) => ({
      ...student,
      amount: value,  
    }));
  });
  setResponse(updated);
  setCourseAmount(value);
};

  const noStudents = Object.values(response).every((students) => students.length === 0);

  return (
    <div>
      <div className="wrapper">
        <DashBoardSidebar />
        <div id="content">
          <DashboardNavbar />
          <section className="manage-students language_wrap invoice-wraper">
            <div className="px-2">
              <div className="d-flex justify-content-between align-items-end mb-4">
                <button
                  onClick={() => navigate(-1)}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    backgroundColor: "#4e9c4b",
                    color: "#fff",
                    border: "none",
                    borderRadius: "30px",
                    padding: "10px 20px",
                    fontSize: "20px",
                    fontWeight: "500",
                    cursor: "pointer",
                    boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                    transition: "all 0.2s ease-in-out",
                  }}
                  onMouseOver={(e) =>
                    (e.currentTarget.style.backgroundColor = "#3c7d3a")
                  }
                  onMouseOut={(e) =>
                    (e.currentTarget.style.backgroundColor = "#4e9c4b")
                  }
                >
                  <FaArrowLeft style={{ fontSize: "16px" }} />
                  {/* Go Back */}
                </button>
                <div
                  className="mb-2"
                  style={{
                    fontSize: "22px",
                    fontWeight: "600",
                    textAlign: "center",
                  }}
                >
                  {attorneyData?.name} Invoice Summary
                </div>
                <BillingFilterDropdown
                  id="attorney-month-filter"
                  label="Month"
                  icon="fa-solid fa-calendar-days"
                  value={monthFilter}
                  onChange={(selectedValue) => {
                    setMonthFilter(selectedValue);
                    fetchData(selectedValue);
                  }}
                  options={[
                    { value: "all", label: "All" },
                    { value: "current", label: "Current" },
                    { value: "previous", label: "Previous" },
                  ]}
                />
              </div>
              {loading ? (
                <div className="d-flex justify-content-center align-items-center" style={{ height: "150px" }}>
                  <ThreeDots height="20" width="52" color="#4fa94d" />
                </div>
              ) : (
                response &&
                Object.entries(response).map(([courseKey, students]) =>
                  students.length > 0 ? (
                    <div key={courseKey} className="billing-course-card">
                      <h3 className="billing-course-title">{courseKey} Students</h3>
                      <div className="billing-table-scroll">
                        <table className="table glade-billing-table">
                          <thead>
                            <tr>
                              <th>Student Name</th>
                              <th>Email</th>
                              <th className="text-center">Course Completed</th>
                              <th>Enrolled Date</th>
                              <th>Amount</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {students.map((r, idx) => (
                              <tr key={r.id || idx}>
                                <td className="billing-student-name">
                                  <Link to={`/editstudent?id=${r.id}`} className="billing-student-link">
                                    {r.name}
                                  </Link>
                                </td>
                                <td>{r.email}</td>
                                <td className="text-center">{r.percentage}%</td>
                                <td>{moment(r.enrolDate).format("MMMM Do YYYY")}</td>
                                <td>
                                  <div className="billing-amount-control">
                                    <span>$</span>
                                    <input
                                      type="text"
                                      value={r.amount}
                                      aria-label={`${r.name} amount`}
                                      onChange={(e) => {
                                        const value = e.target.value;
                                        if (/^\d*\.?\d{0,2}$/.test(value)) {
                                          handleAmountChange(courseKey, idx, value);
                                        }
                                      }}
                                      className="form-control"
                                    />
                                  </div>
                                </td>
                                <td>
                                  <button
                                    onClick={() => handleRemoveStudent(courseKey, idx)}
                                    className="billing-hold-button"
                                  >
                                    Hold
                                  </button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  ) : null
                )
              )}

              {/* Summary Section */}
              {!loading && !noStudents && (
                <div className="billing-summary-card">
                  <div className="billing-summary-row">
                    <span className="billing-summary-label">Apply Amount to All</span>
                    <div className="billing-amount-control">
                      <span>$</span>
                      <input
                        type="text"
                        value={courseAmount}
                        aria-label="Apply amount to all students"
                        className="form-control"
                        onChange={(e) => {
                          if (/^\d*\.?\d{0,2}$/.test(e.target.value)) {
                            applyAmountToAll(e.target.value);
                          }
                        }}
                      />
                    </div>
                  </div>
                  <div className="billing-summary-row">
                    <span className="billing-summary-label">Total Courses Amount</span>
                    <span className="billing-summary-value">${Number(totalCourses).toFixed(2)}</span>
                  </div>
                  <div className="billing-summary-row billing-summary-editable">
                    <div className="d-flex align-items-center gap-2">
                      <span className="billing-summary-label">Service Fee</span>
                      <div className="d-flex align-items-center gap-2">
                        <div className="billing-amount-control">
                          <input
                            type="text"
                            value={serviceFee}
                            aria-label="Service fee percentage"
                            onChange={(e) => setServiceFee(parseFloat(e.target.value || 0))}
                            className="form-control"
                          />
                        </div>
                        <span>%</span>
                      </div>
                    </div>
                    <span className="billing-summary-value">
                      ${((totalCourses * (serviceFee || 0)) / 100).toFixed(2)}
                    </span>
                  </div>
                  <div className="billing-summary-row billing-summary-editable">
                    <div className="d-flex align-items-center gap-2">
                      <span className="billing-summary-label">Credit</span>
                      <div className="billing-amount-control">
                        <span>$</span>
                        <input
                          type="text"
                          value={credit}
                          aria-label="Credit amount"
                          onChange={(e) => setCredit(parseFloat(e.target.value || 0))}
                          className="form-control"
                        />
                      </div>
                    </div>
                    <span className="billing-summary-value">-${credit.toFixed(2)}</span>
                  </div>
                  <div className="billing-summary-row billing-summary-total">
                    <span className="billing-summary-label">Total</span>
                    <span className="billing-summary-value">${grandTotal.toFixed(2)}</span>
                  </div>
                  <div className="billing-export-actions">
                    <button
                      className="btn_brnd"
                      disabled={loadingExcel || loadingPdf || noStudents || grandTotal <= 0}
                      onClick={() => handleExport("excel")}
                    >
                      {loadingExcel ? (
                        <ThreeDots height="18" width="52" color="#4e9c4b" wrapperStyle={{ display: "flex", justifyContent: "center", alignItems: "center" }} />
                      ) : "Export Invoice in Excel"}
                    </button>
                    <button
                      className="btn_brnd"
                      disabled={loadingPdf || loadingExcel || noStudents || grandTotal <= 0}
                      onClick={() => handleExport("pdf")}
                    >
                      {loadingPdf ? (
                        <ThreeDots height="18" width="52" color="#4e9c4b" wrapperStyle={{ display: "flex", justifyContent: "center", alignItems: "center" }} />
                      ) : "Export Invoice in Pdf"}
                    </button>
                  </div>
                </div>
              )}
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default InvoiceMOdalComponent;
